<template>
	<footer class="bg-dark text-white py-lg-5">
		<b-container class="text-center py-4 px-3 px-lg-0">
			<b-row class="py-lg-6">
				<b-col cols="12" lg="1" class="px-0 d-none d-lg-flex" order="0">
					<a :href="$creo.getLang() == 'sv'?'https://www.jm.se/om-oss/' : 'https://www.jm.se/en/about-us/'" target="_blank" class="text-white text-decoration-none">
						<img src="../assets/img/JM_LOGO.png"  height="120" class="position-absolute bottom-logo"/>
					</a>
				</b-col>
				<b-col cols="4" lg="2" offset-lg="1" offset-xl="1" class="footer-block pt-lg-2 pb-lg-0" order="2" order-lg="1">
					<a href="#app" v-scroll-to="'#app'" class="text-white text-decoration-none d-block hover-zoom">
						<b-row>
							<b-col cols="12">
								<p class="medium footertext">
									<span v-if="$creo.getLang() == 'sv'">Till toppen</span>
									<span v-else>To the top</span>
								</p>
							</b-col>
							<b-col cols="12"  class=" footer-block py-lg-2 d-flex align-items-end justify-content-center">
								<img src="../assets/icons/up.svg" width="20" height="20" class="icon middle mb-2">
							</b-col>
						</b-row>
					</a>
				</b-col>

				<b-col cols="4" lg="2" class="footer-block pt-lg-2 pb-lg-0" order="3" order-lg="2">
					<a :href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])" target="_blank" class="text-white text-decoration-none d-block hover-zoom">
						<b-row>
							<b-col cols="12">
								<p class="medium footertext">
									<span v-if="$creo.getLang() == 'sv'">Ladda ner</span>
									<span v-else>Download</span>
								</p>
							</b-col>
							<b-col cols="12" class=" footer-block py-lg-2 d-flex align-items-end justify-content-center">
								<img src="../assets/icons/download.svg" width="20" height="22" class="icon mb-2">
							</b-col>
						</b-row>
					</a>
				</b-col>

				<b-col cols="4" lg="2" class="footer-block pt-lg-2 pb-lg-0" order="4" order-lg="3">
					<a :href="$creo.getLang() == 'sv'?'https://www.jm.se/om-oss/' : 'https://www.jm.se/en/about-us/ '" class="text-white text-decoration-none d-block hover-zoom" target="_blank">
						<b-row>
							<b-col cols="12">
								<p class="medium footertext">
									<span v-if="$creo.getLang() == 'sv'">Till jm.se</span>
									<span v-else>JM website</span>
								</p>
							</b-col>
							<b-col cols="12" class="footer-block py-lg-2 d-flex align-items-end justify-content-center">
								<img src="../assets/icons/pilsne.svg" width="17" height="19" class="icon mb-2">
							</b-col>
						</b-row>
					</a>
				</b-col>

				<b-col cols="10" offset="1" offset-lg="0" lg="3" xl="3" class=" mt-0 footer-block pt-2 pb-2 pb-lg-0" order="1" order-lg="4">
					<b-row class="text-center">
						<b-col cols="12" class="d-none d-lg-flex">
							<p class="medium footertext w-100 text-center">
								<span v-if="$creo.getLang() == 'sv'">Följ oss</span>
								<span v-else>Follow us</span>
							</p>
						</b-col>
						<b-col cols="10"  offset="1" offset-lg="0" lg="12" class=" mt-0 pb-4 footer-block py-lg-2 px-xl-5 d-flex align-items-end justify-content-between">
							<a href="https://www.facebook.com/JMSverige/" target="_blank" class="hover-zoom" v-b-tooltip.hover title="Facebook">
								<img src="../assets/icons/fb.svg" width="31" height="31" class="icon big ">
							</a>
							<a href="https://www.instagram.com/jmsverige/" target="_blank"  class="hover-zoom" v-b-tooltip.hover title="Instagram">
								<img src="../assets/icons/insta.svg" width="31" height="31" class="icon big">
							</a>
							<a href="https://www.linkedin.com/company/jm-ab/" target="_blank"  class="hover-zoom" v-b-tooltip.hover title="Linkedin">
								<img src="../assets/icons/link.svg" width="31" height="31" class="icon big">
							</a>
							<a href="https://twitter.com/jm_ab" target="_blank"  class="hover-zoom" v-b-tooltip.hover title="Twitter">
								<img src="../assets/icons/twitter.svg" width="31" height="31" class="icon big">
							</a>
							<a href="https://www.youtube.com/user/JMSverige" target="_blank"  class="hover-zoom" v-b-tooltip.hover title="Youtube">
								<img src="../assets/icons/youtube.svg" width="31" height="31" class="icon big">
							</a>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<b-row class="pt-4 d-lg-none">
				<b-col cols="12">
					<a href="https://www.jm.se/om-oss/" target="_blank" class="text-white text-decoration-none d-inline-block">
						<img src="../assets/img/JM_LOGO.png"  height="80"/>
					</a>
				</b-col>
			</b-row>
		</b-container>
	</footer>
</template>
<script>
	export default {
		name: 'Footer',
		props: {
			pdfLink: Object
		}
	}
</script>
